import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TemplatesService} from '../../../services/templates.service';
import {Templates} from '../../../models/templates.interface';
// @ts-ignore
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-edit-template',
  templateUrl: './edit-template.component.html',
  styleUrls: ['./edit-template.component.scss']
})
export class EditTemplateComponent implements OnInit {

  editor = ClassicEditor;
  templateEditForm = this.formBuilder.group({
    description: ['', Validators.required],
    subject: ['', Validators.required],
    body: ['', Validators.required]
  });

  get descriptionControl(): FormControl {
    return this.templateEditForm.get('description') as FormControl;
  }
  get subjectControl(): FormControl {
    return this.templateEditForm.get('subject') as FormControl;
  }
  get bodyControl(): FormControl {
    return this.templateEditForm.get('body') as FormControl;
  }

  @Output()
  editEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: Templates,
              private dialogRef: MatDialogRef<EditTemplateComponent>,
              private readonly formBuilder: FormBuilder,
              private readonly templatesService: TemplatesService) { }

  ngOnInit(): void {
    this.descriptionControl.setValue(this.data.description);
    this.subjectControl.setValue(this.data.subject);
    this.bodyControl.setValue(this.data.body);
  }

  sendEditionRequest(): void {
    const dto: Templates | null = this.getEditionRequest();
    if (dto) {
      this.templatesService.editTemplate(dto).subscribe(
        () => {
          this.editEvent.emit();
          this.closeDialog();
        },
        () => {
          this.closeDialog();
        }
      );
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private getEditionRequest(): Templates {
    return {
      id: this.data.id,
      status: this.data.status,
      category: this.data.category,
      description: this.descriptionControl.value,
      subject: this.subjectControl.value,
      body: this.bodyControl.value
    };
  }

}
